export default "__VITE_ASSET__f8e48ee5__"